import { DriverCategory } from "../../../utils/driverPageLocation";
import { DriversListFiltersFormValues } from "./DriversListFiltersFormValues";
import { FilterType } from "../../../models/app/admin/filter";

/* Defaulting all location based values for the driver filters. */

export const driverListFiltersDefaultValues = (
    location?: DriverCategory | string
): Omit<
    DriversListFiltersFormValues,
    "driverLicenceAnalysis" | "vehicleAnalysis"
> => {
    const defaultValues: Omit<
        DriversListFiltersFormValues,
        "driverLicenceAnalysis" | "vehicleAnalysis"
    > = {
        ...(location?.includes("greyfleet") && { greyFleet: true }),
        ...(location?.includes("professionalDrivers") && {
            professional: true,
        }),
    };

    return defaultValues;
};

export const getFilter = (location?: DriverCategory | string): FilterType => {
    return {
        filterId: "",
        filterFields: { ...driverListFiltersDefaultValues(location) },
    };
};
